import React from 'react';
import { Badge, Popover } from 'antd';
import { Label } from './styled';

const ErrorMessages = ({ message }) => <div>{message}</div>;

function LabelHoc({ text, err }) {
  if (err) {
    return (
      <Popover
        content={<ErrorMessages message={err.message} />}
        placement="left"
        // visible={true}
        destroyOnHidden
        trigger="hover"
      >
        <Badge dot>
          <Label>{text}</Label>
        </Badge>
      </Popover>
    );
  }

  return <Label>{text}</Label>;
}

export default LabelHoc;
